// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2M75H","footer":"ModalCreateQualiphyProcedure_footer__2Odt6","additionData":"ModalCreateQualiphyProcedure_additionData__1hiM5"};